import { translate } from '@/translation/translate.ts';
import { Slide } from '@/eventConfig/types.ts';
import { FC } from 'react';
import { useSaveRegistration } from '@/saveRegistration/useSaveRegistration.ts';

interface GridCheckTextProps {
  slide: Slide;
}

export const ConfirmTransmissionText: FC<GridCheckTextProps> = ({ slide }) => {
  const { confirmTransmission, confirmTransmitStatus } = useSaveRegistration();

  const retryTransmission = () => {
    confirmTransmission();
  };

  const Failure = (
    <>
      <span>{translate(slide?.confirmTransmission?.failure)}</span>
      <div>
        <button onClick={retryTransmission}>{translate(slide?.confirmTransmission?.retry)}</button>
      </div>
    </>
  );

  switch (confirmTransmitStatus) {
    case 'unknown':
      return (
        <>
          <span>{translate(slide?.confirmTransmission?.unknown)}</span>
          <span></span>
        </>
      );
    case 'confirming':
      return (
        <>
          <span>{translate(slide?.confirmTransmission?.confirming)}</span>
          <span></span>
        </>
      );
    case 'confirmation-success':
      return (
        <>
          <span>{translate(slide?.confirmTransmission?.success)}</span>
          <span></span>
        </>
      );
    case 'confirmation-failure':
      return Failure;
    default:
      return Failure;
  }
};
